export function saveToStorage<T>(key: string, data: T): void {
  try {
    localStorage.setItem(`econdock_${key}`, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
}

export function loadFromStorage<T>(key: string, defaultValue: T): T {
  try {
    const stored = localStorage.getItem(`econdock_${key}`);
    return stored ? (JSON.parse(stored) as T) : defaultValue;
  } catch (error) {
    console.error('Failed to load from localStorage:', error);
    return defaultValue;
  }
}
